import { render, staticRenderFns } from "./projectShow2.vue?vue&type=template&id=850b2730&scoped=true"
import script from "./projectShow2.vue?vue&type=script&lang=js"
export * from "./projectShow2.vue?vue&type=script&lang=js"
import style0 from "./projectShow2.vue?vue&type=style&index=0&id=850b2730&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850b2730",
  null
  
)

export default component.exports